module.exports = __webpack_public_path__ + "static/media/1929174_1134068398624_6787144_n.a9d461d6.jpg";